// extracted by mini-css-extract-plugin
module.exports = {"cancelOrder":"al","desktop":"bl","mobile":"cl","cancelOrderHeader":"dl","cancelOrderFooter":"el","disabled":"fl","message":"gl","errorMessage":"hl","confirmationMessage":"il"};